import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 24,
  medium: 18,
  small: 12,
  xSmall: 10
};
const SearchIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5312 6C9.37186 6 6 9.37186 6 13.5312C6 17.6906 9.37186 21.0625 13.5312 21.0625C15.431 21.0625 17.1665 20.3591 18.4914 19.1985L23.2558 23.9629L23.9629 23.2558L19.1985 18.4914C20.3591 17.1665 21.0625 15.431 21.0625 13.5312C21.0625 9.37186 17.6906 6 13.5312 6ZM13.5312 7C17.1384 7 20.0625 9.92414 20.0625 13.5312C20.0625 17.1384 17.1384 20.0625 13.5312 20.0625C9.92414 20.0625 7 17.1384 7 13.5312C7 9.92414 9.92414 7 13.5312 7Z",
        fill: "currentColor"
      }
    )
  );
};
SearchIcon.iconName = "SearchIcon";

export { SearchIcon };
